module.exports = __webpack_public_path__ + "976fd3bd4a53ebb9bfbcc9d779fa3191.jpg";